import { render, staticRenderFns } from "./CarisSelectionForm.vue?vue&type=template&id=ec9e1fb2&scoped=true"
import script from "./CarisSelectionForm.vue?vue&type=script&lang=js"
export * from "./CarisSelectionForm.vue?vue&type=script&lang=js"
import style0 from "./CarisSelectionForm.vue?vue&type=style&index=0&id=ec9e1fb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9e1fb2",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fcaris-selection-form%2FCarisSelectionForm.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports